<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isFetchingUserQuotas" :can-cancel="false"></b-loading>
    <div class="level">
      <div class="level-left">
        <h3 class="title is-3">{{userAgent}}</h3>
      </div>
      <div class="level-right">
        <router-link to="/user-managements" class="button is-small">
          <span class="icon">
            <i class="fas fa-arrow-left"></i>
          </span>&nbsp; Go back to list</router-link>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Year</label>
          <div class="control">
            <div class="field">
              <div class="control">
                <div class="select is-small">
                  <select v-model="userAgentAnnualQuota.year" :disabled="createOrEdit == 'Update'">
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Amount</label>
          <div class="control">
            <input type="number" v-model="userAgentAnnualQuota.amount" class="input is-small" v-validate="'required'" name="Amount" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Amount') }}</span>
          </div>
        </div>
      </div>
    </div>
    <button :class="buttonSave" @click="saveUserQuota">{{createOrEdit}}</button>
    &nbsp;
    <button v-show="createOrEdit == 'Update'" class="button is-small" @click="cancelEdit">Cancel</button>
    <div style="clear:both"></div>
    <br />
    <b-table :data="userAgentAnnualQuotaForTable.userAgentAnnualQuotaDetails" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
      <template slot-scope="item">
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Year">
          {{item.row.year}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Amount">
          {{item.row.amount}}
        </b-table-column>
        <b-table-column>
          <button class="button is-small is-warning" @click="editUserQuota(item.row.userAgentAnnualQuotaId)">Edit</button> &nbsp;
          <button class="button is-small is-danger" @click="deleteUserQuota(item.row.userAgentAnnualQuotaId)">Delete</button>
        </b-table-column>
      </template>
    </b-table>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete User Quota</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Are you sure do you want to delete this permanently?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonDelete" @click="deletePermanently">Yes</button>
          <button class="button is-small" @click="cancel">No</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../../frontend/appToast'
import AppButton from '../../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    createOrEdit: 'Create',
    showDeleteModal: false,
    userAgentAnnualQuota: {
      year: 2019
    },
    userAgent: '...',
    userAgentAnnualQuotaForTable: {},
    isFetchingUserQuotas: false,
    buttonSave: appButton.isLoadingSuccess(false),
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  created() {
    const userId = this.$route.params.userId
    if (userId) {
      this.getUserAgentName(userId)
      this.getUserQuotas(userId)
    }
  },
  methods: {
    getUserAgentName(id) {
      this.isFetchingUserQuotas = true
      axios
        .get(`api/users/${id}`)
        .then(response => {
          this.userAgent = `${response.data.firstname} ${
            response.data.lastname
          }`
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => (this.isFetchingUserQuotas = false))
    },
    saveUserQuota() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const userAgentAnnualQuotaId = this.userAgentAnnualQuota
            .userAgentAnnualQuotaId
          if (userAgentAnnualQuotaId) {
            // Edit
            axios
              .put(
                `api/useragentannualquotas/${userAgentAnnualQuotaId}`,
                this.userAgentAnnualQuota
              )
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                appToast.danger(error.response)
              })
              .then(() => {
                this.default()
              })
          } else {
            this.userAgentAnnualQuota.id = this.$route.params.userId
            // CREATE
            axios
              .post(`api/useragentannualquotas`, this.userAgentAnnualQuota)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                appToast.danger(error.response.data)
              })
              .then(response => {
                this.default()
              })
          }
        }
      })
    },
    getUserQuotas(userId) {
      this.isFetchingUserQuotas = true
      axios
        .get(`api/useragentannualquotas/annual-quota-by-user/${userId}`)
        .then(response => {
          this.userAgentAnnualQuotaForTable = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingUserQuotas = false
        })
    },
    editUserQuota(id) {
      axios
        .get(`api/useragentannualquotas/${id}`)
        .then(response => {
          this.userAgentAnnualQuota = response.data
          this.createOrEdit = 'Update'
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteUserQuota(id) {
      this.showDeleteModal = true
      this.userAgentAnnualQuota.userAgentAnnualQuotaId = id
    },
    deletePermanently() {
      if (this.showDeleteModal) {
        this.buttonDelete = appButton.isLoadingDanger(true)
        const userAgentAnnualQuotaId = this.userAgentAnnualQuota
          .userAgentAnnualQuotaId
        if (userAgentAnnualQuotaId) {
          axios
            .delete(`api/useragentannualquotas/${userAgentAnnualQuotaId}`)
            .then(response => {
              appToast.success(response.data)
            })
            .catch(error => {
              console.log(error)
            })
            .then(() => {
              this.default()
            })
        }
      }
    },
    cancel() {
      this.showDeleteModal = false
    },
    default() {
      this.createOrEdit = 'Create'
      this.userAgentAnnualQuota = {
        year: 2019
      }
      this.showDeleteModal = false
      this.getUserQuotas(this.$route.params.userId)
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.buttonDelete = appButton.isLoadingDanger(false)

      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    cancelEdit() {
      this.default()
    }
  }
}
</script>

